import merge from 'lodash.merge'
import camelCase from 'lodash.camelcase'
import { getConstructorForType } from './utils'
import defaultConfig from './defaultConfig'
import commonDefinition from './common'

// extend the default options; inferr some parts also
export default (customConfig) => {
  let config = merge({}, defaultConfig, customConfig)
  // --- CHECKS AND DEFAULTS ---
  if (!config.service.import) {
    config.hooks.error('Attempted to create a service without an import')
    return
  }
  if (!config.service.clientKey) {
    // infer key automatically - careful to remove experimental promise client stuff
    config.service.clientKey = Object.keys(config.service.import).filter(k => k.endsWith('Client') && !k.endsWith('PromiseClient'))[0]
  }
  if (!config.name) {
    // remove Client from the key
    config.name = camelCase(config.service.clientKey.slice(0, -1 * ('Client').length))
  }
  // create a client instance if not provided
  if (!config.service.client) {
    config.service.client = new config.service.import[config.service.clientKey](config.service.address, config.service.credentials, config.service.options)
  }
  // find the constructor for the pagination and sorting
  config.service.features.pagination = getConstructorForType(config, config.service.paginationObjectType)
  config.service.features.sorting = getConstructorForType(config, config.service.sortObjectType)
  // ACTIONS -- overwrites customConfig
  let common = commonDefinition(config)
  config.actions = common.actionDefinitions

  return { config, common }
}
